import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ErrorResponse } from 'src/utilities/restApi/common/types/responses';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

// レポートファイルのダウンロード
export const downloadReportPrsStatus = async (jobId: string) => {
  const config = { headers: await getCommonHeaders() };

  return new Promise<Blob>((resolve, reject) => {
    restApi()
      .getBlob(`/report/prsstatus/joblist/${jobId}/download`, 'application/zip', config)
      .then((response) => {
        resolve(response.data!)
      })
      .catch((error: AxiosError<ErrorResponse>) => {
        reject(error.response?.data)
      });
  });
};